import { render, staticRenderFns } from "./ConnectSocial.vue?vue&type=template&id=1a7dc393&scoped=true&"
import script from "./ConnectSocial.vue?vue&type=script&lang=js&"
export * from "./ConnectSocial.vue?vue&type=script&lang=js&"
import style0 from "./ConnectSocial.vue?vue&type=style&index=0&id=1a7dc393&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7dc393",
  null
  
)

export default component.exports